const keys = {
  disclaimer: {
    titles: {
      car: 'My car:',
      home: 'My home:',
      policyholder: {
        title: 'I or <0>any member of my household:</0>',
        toolTip:
          'You must obtain the consent of the members of your household prior to answering the assertions below.',
      },
    },
    statements: {
      car: {
        carHasOutstandingLoss: { description: 'Is with an outstanding loss, pending claim or has unrepaired damages.' },
        carryDangerousMaterial: {
          description: 'Is used to carry <0>dangerous materials</0>.',
          tooltip: 'Such as explosives or radioactive materials.',
        },
        isRebuilt: {
          description: 'Is modified, rebuilt or used in competitions, exhibitions or races.',
        },
        isRegisteredOutsideOfBoundaries: {
          description: 'Is registered outside of my home province, or is parked away from my home address.',
        },
        isUsedForBusiness: {
          // FIXME: This is a test running to check if the amount of users select isUsedBusiness reduces
          // description: 'Is used for <0>business purpose</0>.',
          // tooltip: 'Driving for applications like Uber or Turo is a business usage.',
          description: 'Is used for business purpose (ex. Uber or Turo).',
        },
      },
      home: {
        exceedsNumberOfResidents: {
          description: {
            condo: {
              on: 'Has 2 or more roommates that are not my family living with me in my unit.',
              qc: 'Has 3 or more roommates that are not my family living with me in my unit.',
            },
            homeowner: {
              on: 'Has 2 or more roommates that are not my family living with me in my home.',
              qc: 'Has 3 or more roommates that are not my family living with me in my home.',
            },
            tenant: {
              on: 'Has 3 or more roommates that are not my family living with me in my unit.',
              qc: 'Has 3 or more roommates that are not my family living with me in my unit.',
            },
          },
        },
        homeHasOutstandingLoss: {
          description:
            'Is under construction, <0>under major renovation</0>, has an outstanding loss, has a pending claim or has unrepaired damages.',
          tooltip: 'Replacement of pipes or kitchen renovation is considered a major renovation.',
        },
        isCondoCorpUnderInsured: {
          description: 'Is part of a Condominium Corporation that has no insurance or is only partially insured.',
        },
        isMobileHome: { description: 'Is a mobile home.' },
        isSecondaryResidence: {
          description: {
            condo: 'Is a secondary place of residence, is not occupied by the owner or will be vacant.',
            homeowner: 'Is a secondary place of residence, is not occupied by the owner or will be vacant.',
            tenant: 'Is a secondary place of residence or will be vacant.',
          },
        },
        isUsedForCommercialActivity: {
          description: 'Is used for any <0>commercial activity</0>.',
          tooltip: 'Home-based business or space rental like Swimply is considered a commercial activity.',
        },
        isUsedForRental: {
          description: 'Is used for  subletting, <0>room rental or short-term rental.</0>',
          tooltip: 'Stay rental through applications like Airbnb is considered a short-term rental.',
        },
      },
      policyholder: {
        hasMedicalConditions: { description: 'Have a driver’s license indicating medical condition restrictions affecting their driving.' },
        hasSuspendedLicence: {
          description: 'Have or had a suspended or revoked driver’s licence in the last 5 years.',
        },
        haveBeenBankrupt: {
          description:
            'Have ever been bankrupt. A bankruptcy that has been liberated for 3 years or more is not considered.',
        },
        haveBeenRefused: {
          description:
            'Have ever been refused coverage or had an insurance policy cancelled. A refusal to renew is considered a cancellation.',
        },
        haveCriminalRecord: { description: 'Have a criminal record or any pending lawsuits against you.' },
        haveExoticAnimal: {
          description:
            'Own a dog of a breed that could be <0>considered dangerous</0> or an exotic animal, saddle animal, farm animal or reptile.',
          tooltip: 'Pitbull, doberman, rottweiler, etc. are considered dangerous breeds.',
        },
      },
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
